import { render, staticRenderFns } from "./WModalImage.vue?vue&type=template&id=1c2b5f4e&scoped=true&"
import script from "./WModalImage.vue?vue&type=script&lang=js&"
export * from "./WModalImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2b5f4e",
  null
  
)

export default component.exports